import React from 'react'
import { Accordion, Form, Button, Row, Col } from 'react-bootstrap'
import { useForm } from 'react-hook-form'

const WorkItem = ({
  work,
  project,
  workStage,
  currentUser,
  onUpdate,
  onToggleCompletion,
  onDelete,
  onOpenAsr,
  onOpenMaterials,
  dragHandleProps,
}) => {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      quantity: work.quantity,
      price_override: work.price_override,
    },
  })

  const completedClass = work.completed ? 'bg-success bg-opacity-10' : ''

  const displayPrice = (price, priceForForeman) => {
    const isAdmin = currentUser?.roles?.includes('admin')
    if (isAdmin && priceForForeman !== price) {
      return (
        <>
          {price.toLocaleString('ru-RU')} ₽ <span className="small">/ {priceForForeman.toLocaleString('ru-RU')} ₽</span>
        </>
      )
    }
    return `${(isAdmin ? price : priceForForeman).toLocaleString('ru-RU')} ₽`
  }

  const handleUpdate = (data) => {
    onUpdate(work.id, data)
  }

  const content = (
    <>
      <Accordion.Header className={`py-3 shadow-none ${completedClass}`}>
        <div className="d-flex flex-column flex-lg-row w-100 justify-content-between align-items-lg-center gap-3">
          <div className="d-flex flex-column align-items-start">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">{work.work_name || 'Работа'}</span>
              {work.completed && <span className="badge bg-success text-white small">✓</span>}
            </div>
            {work.work_base_price && (
              <span className="text-muted small mt-1">
                Базовая цена: {displayPrice(work.work_base_price, work.work_base_price_for_foreman)} · {work.work_unit}
              </span>
            )}
            {work.quantity && (
              <span className="text-muted small mt-1">
                Объем: {work.quantity} {work.work_unit || 'ед.'}
              </span>
            )}
          </div>
          <span className="badge bg-primary bg-opacity-10 text-primary fw-semibold px-3 py-2 fs-6">
            {displayPrice(work.total_price, work.total_price_for_foreman)}
          </span>
        </div>
      </Accordion.Header>
      <Accordion.Body className="bg-light p-4">
        <div className="border-top border-2 border-light py-3 mb-4">
          <h6 className="mb-0 text-muted small fw-semibold text-uppercase">Настройки работы</h6>
        </div>
        <Form onSubmit={handleSubmit(handleUpdate)}>
          <Row className="gy-4 gx-4 align-items-end">
            <Col lg={4} md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold small mb-2">
                  Количество ({work.work_unit || 'ед.'})
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0.01"
                  {...register('quantity', { required: true })}
                />
              </Form.Group>
            </Col>
            <Col lg={4} md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold small mb-2">Цена, руб.</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Использовать базовую"
                  {...register('price_override')}
                />
              </Form.Group>
            </Col>
            <Col lg={4} md={12}>
              <Form.Group>
                <Form.Label className="fw-semibold small mb-2 d-block">Действия</Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    size="sm"
                    variant={work.completed ? 'success' : 'outline-success'}
                    onClick={() => onToggleCompletion(work.id)}
                  >
                    {work.completed ? '✓ Завершена' : 'Завершить'}
                  </Button>
                  <Button variant="primary" size="sm" type="submit">
                    Сохранить
                  </Button>
                  {work.work_has_asr && (
                    <Button
                      variant="info"
                      size="sm"
                      onClick={() => onOpenAsr(work)}
                    >
                      АСР
                    </Button>
                  )}
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => onOpenMaterials(work)}
                  >
                    Материалы
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDelete(work.id)}
                  >
                    Удалить
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Accordion.Body>
    </>
  )

  if (dragHandleProps) {
    return (
      <Accordion.Item eventKey={work.id.toString()} className={`mb-3 rounded-3 border shadow-sm ${completedClass} d-flex`}>
        <div
          {...dragHandleProps}
          className="sortable-handle d-flex align-items-start px-2 py-3 bg-light"
          style={{ cursor: 'grab', touchAction: 'none', borderRadius: '0.375rem 0 0 0.375rem' }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </div>
        <div className="flex-grow-1">
          {content}
        </div>
      </Accordion.Item>
    )
  }

  return (
    <Accordion.Item eventKey={work.id.toString()} className={`mb-3 rounded-3 border shadow-sm ${completedClass}`}>
      {content}
    </Accordion.Item>
  )
}

export default WorkItem
